<!-- LLM 专题页公共咨询按钮 -->
<template>
  <a class="btn" @click="handleClick">
    <span>{{ text }}</span>
    <img
      class="btn__arrow"
      src="../../../assets/coursePage/llm/common/arrow-right-up.png"
      alt=""
    />
  </a>
</template>

<script>
export default {
  name: "ConsultBtn",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.clickZiXun();
    },
  },
};
</script>

<style lang="less" scoped>
.btn {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 96px;
  margin-top: 48px;
  background: url("../../../assets/coursePage/llm/common/btn-bg.png") no-repeat
    center;
  background-size: 100% 100%;
  text-decoration: none;

  span {
    font-family: PingFangSC, PingFang SC;
    font-size: 32px;
    font-weight: 600;
    color: #ffffff;
    line-height: 48px;
  }

  &__arrow {
    width: 24px;
    height: 24px;
    margin-left: 12px;
  }
}
</style>
